import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    title: {
        defaultMessage: 'Stock',
        id: 'iaso.label.stock',
    },
    titleVersion: {
        defaultMessage: 'Stock Rules Version',
        id: 'iaso.label.stockRulesVersion',
    },
    id: {
        defaultMessage: 'Identifier',
        id: 'iaso.label.id',
    },
    nameRequired: {
        id: 'iaso.pages.errors.name',
        defaultMessage: 'Name is required',
    },
    cancel: {
        id: 'iaso.label.cancel',
        defaultMessage: 'Cancel',
    },
    save: {
        id: 'iaso.label.save',
        defaultMessage: 'Save',
    },
    name: {
        defaultMessage: 'Name',
        id: 'iaso.label.name',
    },
    short_name: {
        defaultMessage: 'Short name',
        id: 'iaso.orgUnits.shortName',
    },
    version: {
        defaultMessage: 'Version',
        id: 'iaso.datasources.label.datasourceSource',
    },
    status: {
        defaultMessage: 'Status',
        id: 'iaso.datasources.label.status',
    },
    search: {
        defaultMessage: 'Search',
        id: 'iaso.search',
    },
    edit: {
        defaultMessage: 'Edit',
        id: 'iaso.label.edit',
    },
    see: {
        defaultMessage: 'See',
        id: 'iaso.label.see',
    },
    deleteText: {
        id: 'iaso.label.deleteText',
        defaultMessage: 'This operation cannot be undone.',
    },
    actions: {
        defaultMessage: 'Action(s)',
        id: 'iaso.label.actions',
    },
    updated_at: {
        defaultMessage: 'Updated',
        id: 'iaso.forms.updated_at',
    },
    created_at: {
        defaultMessage: 'Created',
        id: 'iaso.forms.created_at',
    },
    createdBy: {
        defaultMessage: 'Created by',
        id: 'iaso.forms.created_by',
    },
    projectsError: {
        defaultMessage: 'An error occurred while fetching projects list',
        id: 'iaso.snackBar.fetchProjectsError',
    },
    submission: {
        defaultMessage: 'Submission',
        id: 'iaso.instance.titleSingle',
    },
    submissions: {
        defaultMessage: 'Submissions',
        id: 'iaso.instance.title',
    },
    all: {
        defaultMessage: 'All',
        id: 'iaso.forms.all',
    },
    confirm: {
        defaultMessage: 'Confirm',
        id: 'blsq.queryBuilder.confirm',
    },
    projects: {
        defaultMessage: 'Projects',
        id: 'iaso.label.projects',
    },
    orgUnit: {
        defaultMessage: 'Org unit',
        id: 'iaso.label.orgUnitSingle',
    },
    orgUnitsTypes: {
        defaultMessage: 'Org unit types',
        id: 'iaso.label.orgUnitsTypes',
    },
    forms: {
        defaultMessage: 'Forms',
        id: 'iaso.label.forms',
    },
    form: {
        defaultMessage: 'Form',
        id: 'iaso.label.form',
    },
    sku: {
        defaultMessage: 'Stock Keeping Unit',
        id: 'iaso.label.stockkeepingunit',
    },
    rules: {
        defaultMessage: 'Rules',
        id: 'iaso.stock.rules',
    },
    updateMessage: {
        defaultMessage: 'Update SKU',
        id: 'iaso.stock.sku.update',
    },
    deleteRuleTitle: {
        id: 'iaso.stock.rule.dialog.delete',
        defaultMessage: 'Are you sure you want to delete this rule?',
    },
    deleteSkuTitle: {
        id: 'iaso.stock.sku.dialog.delete',
        defaultMessage: 'Are you sure you want to delete this SKU?',
    },
    deleteVersionTitle: {
        id: 'iaso.stock.version.dialog.delete',
        defaultMessage: 'Are you sure you want to delete this version?',
    },
    deleteError: {
        id: 'iaso.errors.label',
        defaultMessage: 'An error occurred',
    },
    deleteSuccess: {
        id: 'iaso.snackBar.delete_successful',
        defaultMessage: 'Deleted successfully',
    },
    saveError: {
        id: 'iaso.errors.label',
        defaultMessage: 'An error occurred',
    },
    saveSuccess: {
        id: 'iaso.snackBar.successful',
        defaultMessage: 'Saved successfully',
    },
    displayUnit: {
        id: 'iaso.stock.display_unit',
        defaultMessage: 'Display Unit',
    },
    displayPrecision: {
        id: 'iaso.stock.display_precision',
        defaultMessage: 'Display Precision',
    },
    draft: {
        defaultMessage: 'Draft',
        id: 'iaso.label.draft',
    },
    unpublished: {
        defaultMessage: 'Unpublished',
        id: 'iaso.label.unpublished',
    },
    published: {
        defaultMessage: 'Published',
        id: 'iaso.label.published',
    },
    copy: {
        defaultMessage: 'Copy',
        id: 'iaso.datasources.button.label.copy',
    },
    unpublish: {
        defaultMessage: 'Unpublish',
        id: 'iaso.workflows.unpublish',
    },
    publish: {
        defaultMessage: 'Publish',
        id: 'iaso.workflows.publish',
    },
    impact: {
        defaultMessage: 'Impact',
        id: 'iaso.stock.impact',
    },
    add: {
        defaultMessage: 'Add',
        id: 'iaso.label.add',
    },
    subtract: {
        defaultMessage: 'Subtract',
        id: 'iaso.label.subtract',
    },
    reset: {
        defaultMessage: 'Reset',
        id: 'iaso.label.reset',
    },
    question: {
        defaultMessage: 'Question',
        id: 'iaso.label.question',
    },
    directStockManipulationForms: {
        defaultMessage: 'Direct Stock Manipulation Forms',
        id: 'iaso.stock.direct_stock_manipulation_forms',
    },
    directStockManipulationFormsExplanation: {
        defaultMessage: 'Direct Stock Manipulation Forms Explanation',
        id: 'iaso.stock.direct_stock_manipulation_forms_explanation',
    },
    infos: {
        defaultMessage: 'Informations',
        id: 'iaso.instance.infos',
    },
    value: {
        defaultMessage: 'Value',
        id: 'iaso.label.value',
    },
    stockItem: {
        defaultMessage: 'Stock Item',
        id: 'iaso.label.stockItem',
    },
    stockItems: {
        defaultMessage: 'Stock Items',
        id: 'iaso.label.stockItems',
    },
    createdDateFrom: {
        defaultMessage: 'Creation date from',
        id: 'iaso.label.createdDateFrom',
    },
    createdDateTo: {
        defaultMessage: 'Creation date to',
        id: 'iaso.label.createdDateTo',
    },
    valueFrom: {
        defaultMessage: 'Value from',
        id: 'iaso.label.valueFrom',
    },
    valueTo: {
        defaultMessage: 'Value to',
        id: 'iaso.label.valueTo',
    },
});

export default MESSAGES;
